<template>
    <div>
        <div v-if="hasWorkflow">
            <workflowInstance :workflowInstanceDto="workflowInstanceDto" />
            <workflowHistory :hideSubmitUser="isClientUser || isRestrictedRole" :workflowInstanceStatusDtoList="workflowInstanceStatusDtoList" />
            <investigationCheckedBox v-if="workflowId==3000 && isAgency" :investigationId="parentId" />
            <workflowSubmit ref="workflowSubmit" :fieldworkRequestErrors="fieldworkRequestErrors" :investigation="investigation"
            :workflowStatusDtoNextList="workflowStatusDtoNextList" :workflowInstanceId="workflowInstanceId"
            v-on:workflowBeforeSubmit="workflowOnBeforeSubmit" v-on:workflowSubmitOnSubmitSuccess="workflowSubmitOnSubmitSuccess" />
            <user-assignment ref="userAssignment" :parentId="parentId" :workflowId="workflowId"></user-assignment>
        </div>
        <div v-else>
            <h4>No Workflow found</h4>
        </div>
     </div>
</template>

<style>

</style>

<script>
import workflowInstance from '@/components/workflow/WorkflowInstance.vue'
import workflowHistory from '@/components/workflow/WorkflowHistory.vue'
import workflowSubmit from '@/components/workflow/workflowSubmit.vue'
import investigationCheckedBox from '@/components/InvestigationCheckedBox.vue'
import userAssignment from '@/components/UserAssignment.vue'

import loggingService from '@/services/util/loggingService'
import componentService from '@/services/util/componentService'
import workflowService from '@/services/workflowService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'

export default {
    components: {
        workflowHistory,
        workflowInstance,
        workflowSubmit,
        investigationCheckedBox,
        userAssignment
    },
    name: 'workflow',
    data: function () {
        return {
            isDebug: false,
            workflowInstanceDto: null,
            workflowInstanceStatusDtoList: null,
            workflowStatusDtoNextList: null,
            onWorkflowSubmitSuccessEventName: 'workflowOnSubmitSuccess',
            onWorkflowBeforeSubmitEventName: 'workflowOnBeforeSubmit',
            hasWorkflow: true
        }
    },
    props: {
        workflowId: { default: null },
        parentId: { default: null },
        fieldworkRequestErrors: { default: null },
        investigation: { default: null }
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => (state.auth.shpoUserDto || {})
        }),
        componentName: function () {
            return componentService.getComponentNameDebug(this)
        },
        workflowInstanceId: function () {
            if (this.workflowInstanceDto == null) {
                return null
            }

            return this.workflowInstanceDto.workflowInstanceId
        },
        isAgency: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser])
        },
        isRestrictedRole: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.RestrictedRoleList)
        },
        isClientUser: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ClientUser])
        }
    },

    watch: {
        workflowId: function (val) {
            loggingService.log(this.isDebug, this.componentName + ' - watch.workflowId', val)

            this.loadData()
        },
        parentId: function (val) {
            loggingService.log(this.isDebug, this.componentName + ' - watch.parentId', val)

            this.loadData()
        }
    },
    created () {
        loggingService.log(this.isDebug, this.componentName + ' - created', ' - workflowId: ' + this.workflowId + ', parentId: ' + this.parentId)
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName + ' - mounted', ' - workflowId: ' + this.workflowId + ', parentId: ' + this.parentId)
    },
    methods: {
        loadData () {
            this.hasWorkflow = true
            if (this.workflowId !== 0 && this.parentId) {
                this.workflowInstanceDto = null
                this.workflowInstanceStatusDtoList = null
                this.workflowStatusDtoNextList = null

                if (this.$refs.workflowSubmit) this.$refs.workflowSubmit.clearForm()
                var handle = this
                workflowService.getWorkflowInstanceDto(this.$http, this.workflowId, this.parentId).then(function (response) {
                    if (!response.data) {
                        handle.hasWorkflow = false
                        return
                    }
                    handle.workflowInstanceDto = response.data
                    handle.$refs.userAssignment.loadData()
                    Promise.all([ handle.loadHistory(), handle.loadNextStatusList() ]).then(results => {
                        loggingService.log(handle.isDebug, 'Workflow', 'loadData, post promises')
                    })
                })
            } else {
                loggingService.log(this.isDebug, 'Workflow', `Not loading because not fulfilled: workflowId: ${this.workflowId} parentId: ${this.parentId}`)
            }
        },
        loadHistory () {
            this.workflowInstanceStatusDtoList = null
            return workflowService.listWorkflowStatusInstanceDto(this.$http, this.workflowInstanceDto.workflowInstanceId).then(response => {
                this.workflowInstanceStatusDtoList = response.data
                if (this.isClientUser || this.isRestrictedRole) {
                    this.workflowInstanceStatusDtoList.forEach(o => {
                        o.createdBy = ''
                    })
                }
            })
        },
        loadNextStatusList () {
            this.workflowStatusDtoNextList = null
            var handle = this
            return workflowService.listNextWorkflowStatusDto(handle.$http, handle.workflowInstanceDto.workflowInstanceId).then(function (response) {
                handle.workflowStatusDtoNextList = response.data
                loggingService.log(handle.isDebug, 'Workflow', 'load next workflow count' + handle.workflowStatusDtoNextList.length)
            })
        },
        workflowSubmitOnSubmitSuccess (validationResult) {
            loggingService.log(this.isDebug, this.componentName, 'workflowSubmitOnSubmitSuccess')
            loggingService.logRaw(validationResult)

            loggingService.log(this.isDebug, this.componentName + ' - workflowSubmitOnSubmitSuccess', 'calling loadData')
            this.loadData()

            loggingService.log(this.isDebug, this.componentName + ' - workflowSubmitOnSubmitSuccess', 'emit event: ' + this.onWorkflowSubmitSuccessEventName)
            this.$emit(this.onWorkflowSubmitSuccessEventName, validationResult)
        },
        workflowOnBeforeSubmit () {
            loggingService.log(this.isDebug, this.componentName + ' - workflowOnBeforeSubmit', 'emit event: ' + this.onWorkflowBeforeSubmitEventName)
            this.$emit(this.onWorkflowBeforeSubmitEventName)
        }
    }
}
</script>



// WEBPACK FOOTER //
// Workflow.vue?23ecb49c